<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container" :class="classContainer">                    
                    <i @click="close()" class="el-icon-error"></i>
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: "modal",
        props: ['classContainer'],
        methods: {
            close() {
                this.$root.$emit('closeModal')
            }
        }
    }
</script>
<style lang="scss">
    .modal {
        &-mask {
            position: fixed;
            z-index: 1000;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, .5);
            display: table;
            transition: opacity .3s ease;
        }
        &-wrapper {
            display: table-cell;
            vertical-align: middle;
            position: relative;
            
            .el-icon-error {
                position: absolute;
                top: 1%;
                right:1%;
                font-size: 30px;
                cursor: pointer;
                color: #8f0ced;
                &:hover {
                    color: #8f0ced6e;
                }
            }
        }
        &-container {
            position: relative;
            width: auto;
            max-width: 50%;
            margin: 0px auto;
            padding: 20px 30px;
            background-color: #fff;
            border-radius: 2px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
            transition: all .3s ease;
            font-family: Helvetica, Arial, sans-serif;
            height: 90%;
            overflow-y: scroll;
        }
        &-header h3 {
            margin-top: 0;
            color: #42b983;
        }
        &-body {
            margin: 20px 0;
        }
        &-default-button {
            float: right;
        }
        &--enter {
            opacity: 0;
        }
        &-leave-active {
            opacity: 0;
        }
        &-enter &-container,
        &-leave-active &-container {
            -webkit-transform: scale(1.1);
            transform: scale(1.1);
        }
        
    }

    .height {
        &--xs {
            max-height: 198px;
        }
    }
    .o-hidden {
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Modals/modal.vue